module.exports = __webpack_public_path__ + "assets/e2d4458a43fdf5a6ec5c177dcac746c4.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/denoms/denom-8.mp3
 ** module id = 473
 ** module chunks = 0
 **/